import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { MdMailOutline } from "react-icons/md";
import { IsponsoreTrainees } from "../../models/admin/sponsored-trainees.model";
import trainerRegistration from "../../services/trainer/trainerRegistration";
import userService from "../../services/user.service";

export const EditUserModal: React.FC<any> = ({
  isOpen,
  onClosed,
  isUser = false,
  userDetails,
  reload,
}: {
  isUser: boolean;
  isOpen: any;
  onClosed: any;
  userDetails: IsponsoreTrainees;
  reload: any;
}) => {
  const [gender, setGender] = useState<any[]>([]);
  const toast = useToast();
  const courseFormatRef = useRef<HTMLSelectElement>(null);
  const [user, setUser] = useState<IsponsoreTrainees | any>();
  const [nationality, setNationality] = useState<any[]>([]);
  const [nationalityId, setNationalityId] = useState<number>();
  const [state, setState] = useState<any[]>([]);

  useEffect(() => {
    
    setUser(userDetails)
    const maingender = [
      {
        id: "1",
        title: "Male",
      },
      {
        id: "2",
        title: "Female",
      },
    ];
    setGender(maingender);
    setRegisteredUser();
    userService.getUserProfile(userDetails?.user_id?.toString()).then((profile) => { console.log(profile); }); // edit user
    trainerRegistration
      .getNationality()
      .then((res) => {
        setNationality(res.data.data);
      })
      .catch((error) => {
        console.error(error)
      })
  }, [user?.id]);


  useEffect(() => {
    const getState = (nationality_id: any) => {
      trainerRegistration.getState(nationality_id).then((res) => {
        setState(res.data.data);
        
      });
    };

    getState(nationalityId)
  },[])



  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      const regex: any = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      if (!values.firstName) {
        errors.firstName = "First Name is required";
      }
      if (!values.lastName) {
        errors.lastName = "Last Name is required";
      }
      if (!values.emailAddress) {
        errors.emailAddress = "Email Address is required";
      }
      if (!regex.test(values.emailAddress)) {
        errors.emailAddress = "Please enter a valid email address";
      }
      if (!values.phoneNumber) {
        errors.phoneNumber = "Phone Number is required";
      }
      if (
        values.phoneNumber.toString().length < 10 ||
        values.phoneNumber.toString().length > 10
      ) {
        errors.phoneNumber = "Please enter valid phone number";
      }
      if (!values.dob) {
        errors.dob = "Date of Birth is required";
      }
      if (new Date().getFullYear() - new Date(values.dob).getFullYear() < 0) {
        errors.dob = "Please select valid date";
      } else if (
        new Date().getFullYear() - new Date(values.dob).getFullYear() <
        15
      ) {
        errors.dob = "Minimum age should be 15years";
      }
      if (!values.gender) {
        errors.gender = "Gender is required";
      }
      return errors;
    },
    initialValues: {
      firstName: "",
      lastName: "",
      otherName: "",
      stateOfResidence: "",
      emailAddress: "",
      phoneNumber: "",
      phoneNumber2: "",
      dob: "",
      gender: "",
      nationality: "",
      stateOfOrigin: "",
    },
    onSubmit: async (values) => {
      // navigate(routes.VerifyEmail)

      const basicDetails = {
        firstname: values.firstName,
        lastname: values.lastName,
        email: values.emailAddress,
        phone: values.phoneNumber.toString(),
        dob: values.dob,
        gender: values.gender,
        nationality: values.nationality,
        stateofresidence: values.stateOfResidence,
        stateoforigin: values.stateOfOrigin,
      };


      try {
        const preReg = await userService.editUser(user?.user.uuid,basicDetails);
        if (preReg) {
          
          onCloseModal()
          toast({
            title: "User",
            description: `User updated successfully`,
            status: "success",
          });
        }
      } catch (error: any) {
        
        toast({
          title: "User",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });
  const setRegisteredUser = () => {
    if (user) {
      console.log(user, "User")
        const names =user.user.name.split('  ')
      formik.setValues({
        firstName: names[0],
        lastName: names[1],
        otherName: "",
        stateOfResidence: "",
        emailAddress: user?.user?.email,
        phoneNumber: user?.user.phone ?  "0" + user?.user.phone : '',
        phoneNumber2: "",
        dob: user?.user?.dob,
        gender: user?.user?.gender,
        nationality: "",
        stateOfOrigin: "",
      });
    }
  };


 const onCloseModal = () => {
    onClosed()
    reload()
    formik.resetForm()
    setUser(undefined)
  }
  

  return (
    <>
      <Modal
        isOpen={isOpen && isUser}
        onClose={onCloseModal}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={4}>
          <ModalHeader>
            {
              <Text
                fontSize="21px"
                fontWeight="700"
                textTransform="none"
                color="#2B2B2B"
              >
                Edit User 
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={6}>
            <Box mt={2}>
              <form onSubmit={formik.handleSubmit}>
                <HStack  mb="25px" alignItems={"flex-start"}>
                  <FormControl
                    isInvalid={
                      formik.errors.firstName && formik.touched.firstName
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      First Name
                    </FormLabel>
                    <Input
                      bg="inputText.500"
                      placeholder="Enter Name"
                      value={formik.values.firstName}
                      name="firstName"
                      onChange={formik.handleChange}
                      fontSize={12}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.firstName}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    isInvalid={
                      formik.errors.lastName && formik.touched.lastName
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Last Name
                    </FormLabel>
                    <Input
                      bg="inputText.500"
                      placeholder="Enter last Name"
                      value={formik.values.lastName}
                      name="lastName"
                      onChange={formik.handleChange}
                      fontSize={12}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.lastName}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>
                <HStack mb="25px" mt={6} alignItems={"flex-start"}>
                  <FormControl
                    isInvalid={
                      formik.errors.nationality && formik.touched.nationality
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Nationality
                    </FormLabel>
                    <Select
                      variant="outline"
                      bg="inputText.500"
                      size="md"
                      placeholder="Nationality"
                      value={formik.values.nationality}
                      name="nationality"
                      onChange={formik.handleChange}
                      fontSize={12}
                      color="brand.subtitle"
                    >
                      {nationality.map((each) => (
                        <option key={each.id} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.nationality}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>
                <HStack mt={6} alignItems={"flex-start"}>
                  <FormControl
                    isInvalid={
                      formik.errors.stateOfResidence &&
                      formik.touched.stateOfResidence
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      State of Residence
                    </FormLabel>
                    <Select
                      variant="outline"
                      bg="inputText.500"
                      size="md"
                      placeholder="State"
                      value={formik.values.stateOfResidence}
                      name="stateOfResidence"
                      onChange={formik.handleChange}
                      fontSize={12}
                      color="brand.subtitle"
                    >
                      {state.map((each) => (
                        <option key={each.id} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.stateOfResidence}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                    isInvalid={
                      formik.errors.stateOfOrigin &&
                      formik.touched.stateOfOrigin
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      State of Origin
                    </FormLabel>
                    <Select
                      variant="outline"
                      bg="inputText.500"
                      size="md"
                      placeholder="State"
                      value={formik.values.stateOfOrigin}
                      name="stateOfOrigin"
                      onChange={formik.handleChange}
                      fontSize={12}
                      color="brand.subtitle"
                    >
                      {state.map((each) => (
                        <option key={each.id} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.stateOfOrigin}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>
                <HStack mt={6} alignItems={"flex-start"}>
                  <FormControl
                    isInvalid={
                      formik.errors.emailAddress && formik.touched.emailAddress
                        ? true
                        : false
                    }
                  >
                    <FormLabel color="brand.subtitle" fontSize={12}>
                      Email Address{" "}
                    </FormLabel>
                    <InputGroup>
                      <InputLeftElement
                        color="brand.subtitle"
                        pointerEvents="none"
                        children={<MdMailOutline />}
                      />
                      <Input
                        type="email"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder="alex@gmail.com"
                        onChange={formik.handleChange}
                        fontSize={13}
                        value={formik.values.emailAddress}
                      />
                    </InputGroup>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.emailAddress}{" "}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                    isInvalid={
                      formik.errors.phoneNumber && formik.touched.phoneNumber
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Phone Number
                    </FormLabel>
                    <Input
                      type="number"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="080*******"
                      onChange={formik.handleChange}
                      fontSize={13}
                      value={formik.values.phoneNumber}
                    />

                    <FormErrorMessage fontSize={12}>
                      {formik.errors.phoneNumber}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>

                <HStack mb="25px" mt={6} alignItems={"flex-start"}>
                  <FormControl
                    isInvalid={
                      formik.errors.dob && formik.touched.dob ? true : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Date of Birth
                    </FormLabel>
                    <InputGroup>
                      <Input
                        placeholder="Select Date of Birth"
                        type="date"
                        bg="inputText.500"
                        name="dob"
                        value={formik.values.dob}
                        onChange={formik.handleChange}
                        fontSize={12}
                      />
                      {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                    </InputGroup>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.dob}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                    isInvalid={
                      formik.errors.gender && formik.touched.gender
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Gender
                    </FormLabel>
                    <Select
                      ref={courseFormatRef}
                      variant="outline"
                      bg="inputText.500"
                      size="md"
                      value={formik.values.gender}
                      fontSize={12}
                      placeholder="Select Gender"
                      name="gender"
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      color="brand.subtitle"
                    >
                      {gender.map((each) => (
                        <option key={each.id} value={each.title}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.gender}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>

                <Flex justifyContent="flex-end" mt={6}>
                  <HStack>
                    <Button
                      py="13px"
                      px="30px"
                      mt="30px"
                      type="submit"
                      fontSize={11}
                      isLoading={formik.isSubmitting}
                      borderRadius={0}
                      colorScheme="red"
                      size="sm"
                    >
                      Confirm
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
